import React from "react";
import { RadioCheckBox } from "assets/scss/common/controls/inputRadioCheckBox";


export const CheckBox = ({ isChecked, borderRadius, dataTestId }: CheckBoxProps) => (
  <div className="check">
    <RadioCheckBox className="select" borderRadius={borderRadius} dataTestId={dataTestId}>
      <label
        className="control control--checkbox"
      >
        <input
          type="checkbox"
          data-testid={dataTestId}
          className={isChecked ? "checked" : ""}
        />
        <div className="control__indicator" />
      </label>
    </RadioCheckBox>
  </div>
);
